
@if (isLoggedin()) {
  <nav role="navigation" id="main-nav">
    <div id="nav-header">
      <img src="../../../css/images/smoothiz-w.png" title="SMOOTHIZ by xpertiz team" />
      <span>by Xpertiz team</span>
    </div>
    <ul class="nav nav-pills nav-stacked">
      <li [ngClass]="{'active' : pageName()==='Dashboard'}" role="presentation"><a [routerLink]="['Dashboard']"><i class="material-icons" style="color: #9b59b6">&#xE871;</i><span>Dashboard</span></a></li>
      <li [ngClass]="{'active' : pageName()==='Time Management'}" role="presentation"><a [routerLink]="['TimeManagement']"><i class="material-icons" style="color: #23C7AF">&#xE878;</i><span>Time management</span></a></li>
      <li [ngClass]="{'active' : pageName()==='Directory'}" role="presentation"><a [routerLink]="['Directory']"><i class="material-icons" style="color: #BD8963">&#xE853;</i><span>Directory</span></a></li>
      <li [ngClass]="{'active' : pageName()==='Timesheet Check'}" role="presentation"><a [routerLink]="['TSCheck']"><i class="material-icons" style="color: #fd90b5">&#xE86C;</i><span>Timesheet Check</span></a></li>
      <li [ngClass]="{'active' : pageName()==='Planning'}" role="presentation"><a [routerLink]="['Planning']"><i class="material-icons" style="color: #3D9BC5">&#xE192;</i><span>Planning</span></a></li>
      <li [ngClass]="{'active' : pageName()==='TechRadar'}" role="presentation"><a [routerLink]="['TechRadar']"><i class="material-icons" style="color: #c53dae">&#xe1b3;</i><span>TechRadar</span></a></li>
      @if (isAdmin()) {
        <li [ngClass]="{'active' : pageName()==='Event Management'}" role="presentation"><a [routerLink]="['EventManagement']"><i class="material-icons" style="color: #9895ee">&#xE614;</i><span>Event management</span></a></li>
      }
      @if (isAdmin()) {
        <li [ngClass]="{'active' : pageName()==='Users Administration'}" role="presentation"><a [routerLink]="['UsersAdministration']"><i class="material-icons" style="color: #F47964">&#xE8D3;</i><span>Users Administration</span></a></li>
      }
      @if (isAdmin()) {
        <li [ngClass]="{'active': pageName()==='Reporting'}" role="presentation">
          <a [routerLink]="['Reporting']">
            <i class="material-icons" style="color: #27ae60">&#xE85B;</i>
            <span>Reporting</span>
          </a>
        </li>
      }
    </ul>
  </nav>
}
